import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";
import { KPMG_URL } from "@util/constant";

/**
 * Component to render KPMG section on Partners page
 */
const KPMGSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="kpmg-section-component">
      <AccordionV2
        testId="kpmg"
        className="border-x py-4"
        headerChildren={<EventsAwardsAccordionHeader title="KPMG" />}
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>
            KPMG in Singapore is part of a global network of professional
            services firms providing Audit, Tax and Advisory services. The
            independent member firms of the KPMG network have 174,000
            professionals working together to deliver value in 155 countries
            worldwide. In the ASEAN region, member firms operate across all 10
            countries, providing professional services supporting the growth,
            compliance and performance objectives of clients. These services
            include audit, tax, business planning, and advice on fundraising,
            acquisitions, process improvements, and risk management. We provide
            services to business corporations, governments and public sector
            agencies and not-for-profit organisations, who look to us for a
            consistent standard of service based on our professional
            capabilities, global industry insight and local knowledge.
          </p>

          <p>
            For more information, visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={KPMG_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.kpmg.com.sg
            </a>
            .
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default KPMGSection;
